import { Button } from '@coolblue-development/freddy';
import CassieLogo from '../../assets/cassie.svg';
import { getCassiePwaProtocolUrl } from './constants';

const CassieShowButton: React.FC = () => {
  const handleOnShowCassieClick = (): void => {
    window.open(getCassiePwaProtocolUrl(), '_blank');
  };

  return (
    <Button
      endIcon={<CassieLogo />}
      onClick={handleOnShowCassieClick}
      variant="secondary"
      size="small"
      sx={{ height: '37px', svg: { width: '20px', height: '24px' } }}
    />
  );
};

export default CassieShowButton;
